import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';

export const isAutomaticCheckOnboarding = (onboarding: EntityOnboarding) => {
  return onboarding.kind === 'adhoc_vendor_call' || onboarding.kind === 'continuous_monitoring_watchlist_check';
};

export const onboardingHasPlaybook = (onboarding: EntityOnboarding) => {
  return (
    onboarding.playbook &&
    onboarding.kind !== 'document' &&
    onboarding.kind !== 'adhoc_vendor_call' &&
    onboarding.kind !== 'continuous_monitoring_watchlist_check'
  );
};

export const isRunningOnboarding = (onboarding: EntityOnboarding) =>
  onboarding.status === 'pending' && !onboarding.deactivated;

/** An automatic check runs all the time, so its status only matters while it runs or once it errors. */
export const hasVisibleStatus = (onboarding: EntityOnboarding) =>
  !isAutomaticCheckOnboarding(onboarding) || isRunningOnboarding(onboarding) || onboarding.status === 'error';
